import React, { Dispatch, SetStateAction, useState } from 'react';
import PersonalInfo from './PersonalInfo';
import Addresses from './Addresses';
import Devices from './Devices';
import ConnectedAccounts from './ConnectedAccounts';
import SecurityPrivacy from './SecurityPrivacy';
import { UserInfo } from '../types/User';
import CustomSnackbar from '../../components/CustomSnackbar';

interface SettingsPageProps {
  userInfo: UserInfo;
  setUserInfo: Dispatch<SetStateAction<UserInfo>>;
  handleUserInfoChange: (updatedInfo: UserInfo) => void;
}

const SettingsPage: React.FC<SettingsPageProps> = ({ userInfo, handleUserInfoChange }) => {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const closeSnackbar = () => {
    setIsSnackbarOpen(false);
  };

  return (
    <div className="container">
      <div className="my-settings__inner-container">
        <CustomSnackbar message={snackbarMessage} open={isSnackbarOpen} onClose={closeSnackbar} />
        <PersonalInfo
          firstName={userInfo.firstName}
          lastName={userInfo.lastName}
          userEmail={userInfo.email}
          avatarUrl={userInfo.avatarUrl}
          userId={userInfo.userId}
          handleUserInfoChange={handleUserInfoChange}
          setSnackbarMessage={setSnackbarMessage}
          setIsSnackbarOpen={setIsSnackbarOpen}
        />
        <Addresses
          userEmail={userInfo.email}
          setSnackbarMessage={setSnackbarMessage}
          setIsSnackbarOpen={setIsSnackbarOpen}
        />
        <Devices setIsSnackbarOpen={setIsSnackbarOpen} setSnackbarMessage={setSnackbarMessage} />
        <ConnectedAccounts setSnackbarMessage={setSnackbarMessage} setIsSnackbarOpen={setIsSnackbarOpen} />
        <SecurityPrivacy
          userEmail={userInfo.email}
          setSnackbarMessage={setSnackbarMessage}
          setIsSnackbarOpen={setIsSnackbarOpen}
        />
      </div>
    </div>
  );
};

export default SettingsPage;
